import React, { useState, useEffect } from 'react'
import { Card, CardBody, Button, UncontrolledTooltip, Row, Col, Input } from 'reactstrap'

import Lang from 'Lang/General'

const ReorderItemCard = props => {
  const [ isModifyDisplayOrder, setIsModifyDisplayOrder ] = useState( false )
  const [ currentDisplayOrder, setCurrentDisplayOrder ] = useState(1)

  useEffect(() => {
    if ( isModifyDisplayOrder ) {
      setCurrentDisplayOrder( props.itemIndex + 1 )
    }
  }, [ isModifyDisplayOrder ])

  return (
    <Card 
      className="mb-1"
      data-reorder-id={ props.item.value }
      color={ props.selectedDofToReorderId === props.item.value ? "success" : "" } 
      outline={ props.selectedDofToReorderId === props.item.value }
      style={{ userSelect: 'none' }}
    >
      <CardBody>
        <Row className='d-flex flex-row flex-wrap align-items-center' >
          <Col xs="3" >
            { isModifyDisplayOrder ? (
              <Input 
                type="number" 
                min={ 1 }
                max={ props.orderedDigitalOrderForms.length }
                value={ currentDisplayOrder } 
                onChange={ e => setCurrentDisplayOrder( e.target.value ) } 
              />
            ) : (
              <span>{ Lang[ 'NUMBER_ABBV' ][ props.data.languageReducer.lang ] } { props.itemIndex + 1 }</span>
            ) }  
          </Col>
          <Col xs="2" >
            <Button 
              color="success" 
              style={{ display: isModifyDisplayOrder ? "block" : "none" }}
              id={ `reorder-item-card-save-${props.item.value}-btn` } 
              onClick={ () => {
                props.reorderDof({ oldIndex: props.itemIndex, newIndex: currentDisplayOrder - 1 }) 
                setIsModifyDisplayOrder( false )
              }}
              disabled={ currentDisplayOrder === props.item.display_order }
            >
              <i className="pe-7s-check"></i>
            </Button>
            <UncontrolledTooltip target={ `reorder-item-card-save-${props.item.value}-btn` } placement="top">{ Lang[ 'SAVE' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
            <Button 
              color="primary" 
              style={{ display: isModifyDisplayOrder ? "none" : "block" }}
              id={ `reorder-item-card-edit-${props.item.value}-btn` } 
              onClick={ () => setIsModifyDisplayOrder( true ) }>
              <i className="pe-7s-pen"></i>
            </Button>
            <UncontrolledTooltip target={ `reorder-item-card-edit-${props.item.value}-btn` } placement="top">{ Lang[ 'CONFIGURE_ORDER' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
          </Col>
          <Col xs="7" >
            <span>{ props.item.label }</span>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default ReorderItemCard